import React from "react";
import { fmtEuro, MONTHS_EL } from "@/lib/format";


export default function TipSlips({ name, month, employees }) {
  return (
    <div id="tip-slips" className="print-area fixed -left-[10000px] top-0 w-[800px] bg-white p-6" aria-hidden>
      <div className="font-serif text-2xl text-[#45423C] mb-4">Αποδείξεις Tips — {name} ({MONTHS_EL[month]})</div>
      {employees.map((e) => (
        <div key={e.employee} className="payslip-page bg-white border border-[#E3DED4] rounded-xl overflow-hidden mb-4">
          <div className="bg-[#6E7A63] text-white px-6 py-4 flex items-center gap-3">
            <div>
              <img src="/brand/taf-logo-white.png" alt="TAF Beach Villas" className="h-8 w-auto object-contain" />
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/70 mt-2">Απόδειξη Tips · {MONTHS_EL[month]}</div>
            </div>
          </div>
          <div className="px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="font-serif text-lg text-[#45423C]">{e.employee}</div>
              <div className="font-serif text-2xl text-[#6E7A63] tabular">{fmtEuro(e.tips)}</div>
            </div>
            <div className="mt-3 space-y-1">
              {e.breakdown.map((b) => (
                <div key={b.label} className="flex justify-between text-sm py-1 border-b border-dashed border-[#E3DED4]">
                  <span className="text-[#6F6A60]">{b.label} ({b.units}μον.)</span>
                  <span className="tabular font-medium text-[#45423C]">{fmtEuro(b.tips)}</span>
                </div>
              ))}
            </div>
            <div className="mt-3 text-[10px] text-[#6F6A60]">Διανομή service charge σε Ευρώ (€).</div>
          </div>
        </div>
      ))}
    </div>
  );
}
